import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "./PrivateEquity.css";
import Testimonial from "../../../Testimonial/Testimonial";

const PrivateEquity = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  return (
    <div>
      <Helmet>
        <title>
          Private Equity Tech Solutions | Advanced Investment Technology Stack
        </title>
        <meta
          name="description"
          content="Cutting-edge technology solutions for private equity firms, featuring AI-driven analytics, blockchain security, and data visualization tools for smarter investment decisions."
        />
        <meta
          name="keywords"
          content="private equity technology, investment tech stack, PE software solutions, financial analytics tools, AI for private equity, blockchain in investments, data visualization finance, deal flow management, portfolio monitoring, LP reporting tools, investment decision support, fund management software, alternative investments tech, due diligence technology, investment risk analysis, financial modeling software, ESG analytics, investment performance tracking, capital call management, investor relations platform, deal sourcing technology, private markets software, investment thesis analysis, value creation tools, exit strategy planning, fund administration software, investment workflow automation, private equity CRM, investment data aggregation, financial reporting automation"
        />
      </Helmet>

      <div className="mk-private-equity">
        {/* Hero Section */}
        <section className="mk-pe-hero">
          <div className="mk-pe-hero-content">
            <h1 className="mk-pe-main-title">Private Equity Solutions</h1>
            <p className="mk-pe-hero-text">
              Driving growth and value creation through strategic investments
              and operational excellence
            </p>
 <a
  href="https://wa.me/919155599968?text=Hi!%20I%20am%20interested%20in%20understanding%20your%20Private%20Equity%20approach%20and%20investment%20strategies.%20Please%20connect%20me%20with%20your%20team%20for%20more%20details."
  target="_blank"
  rel="noreferrer"
>
  <button className="mk-pe-cta-button">Explore Our Approach</button>
</a>

          </div>
          <div className="mk-pe-hero-animation">
            <div className="mk-pe-circle-graph"></div>
          </div>
        </section>

        {/* Services Section */}
        <section className="mk-pe-services">
          <h2 className="mk-pe-section-title">Our Private Equity Services</h2>
          <div className="mk-pe-services-grid">
            <div className="mk-pe-service-card">
              <div className="mk-pe-service-icon mk-pe-icon-investment"></div>
              <h3>Investment Sourcing</h3>
              <p>
                Identifying and evaluating high-potential investment
                opportunities across diverse sectors.
              </p>
            </div>
            <div className="mk-pe-service-card">
              <div className="mk-pe-service-icon mk-pe-icon-due-diligence"></div>
              <h3>Due Diligence</h3>
              <p>
                Comprehensive analysis of financial, operational, and market
                factors to mitigate risks.
              </p>
            </div>
            <div className="mk-pe-service-card">
              <div className="mk-pe-service-icon mk-pe-icon-value-creation"></div>
              <h3>Value Creation</h3>
              <p>
                Implementing strategic initiatives to enhance portfolio company
                performance and growth.
              </p>
            </div>
            <div className="mk-pe-service-card">
              <div className="mk-pe-service-icon mk-pe-icon-exit-strategy"></div>
              <h3>Exit Strategy</h3>
              <p>
                Maximizing returns through well-timed and strategically executed
                exit processes.
              </p>
            </div>
            <div className="mk-pe-service-card">
              <div className="mk-pe-service-icon mk-pe-icon-portfolio"></div>
              <h3>Portfolio Management</h3>
              <p>
                Active oversight and strategic guidance to optimize performance
                across investment portfolios.
              </p>
            </div>
            <div className="mk-pe-service-card">
              <div className="mk-pe-service-icon mk-pe-icon-fundraising"></div>
              <h3>Fundraising Advisory</h3>
              <p>
                Structuring and capital raising support for private equity funds
                and investment vehicles.
              </p>
            </div>
            <div className="mk-pe-service-card">
              <div className="mk-pe-service-icon mk-pe-icon-restructuring"></div>
              <h3>Corporate Restructuring</h3>
              <p>
                Strategic reorganization to enhance efficiency, profitability,
                and market positioning.
              </p>
            </div>
            <div className="mk-pe-service-card">
              <div className="mk-pe-service-icon mk-pe-icon-transaction"></div>
              <h3>Transaction Support</h3>
              <p>
                End-to-end assistance in deal structuring, negotiation, and
                transaction execution.
              </p>
            </div>
          </div>
        </section>

        {/* Approach Section */}
              <section className="mk-pe-approach">
        <div className="mk-pe-approach-content">
          <h2 className="mk-pe-section-title">Our Investment Approach</h2>
          <p className="mk-pe-approach-text">
            At MK eTech, we employ a disciplined, research-driven approach to private equity investing. 
            Our team of experienced professionals leverages deep industry knowledge and analytical rigor 
            to identify undervalued assets with significant growth potential. We combine strategic vision 
            with operational expertise to transform businesses and create sustainable value.
          </p>
          
          <div className="mk-pe-approach-details">
            <div className="mk-pe-approach-point">
              <div className="mk-pe-approach-icon mk-pe-icon-strategy"></div>
              <div className="mk-pe-approach-info">
                <h3>Sector-Focused Strategy</h3>
                <p>We concentrate on industries where we have deep expertise and can identify unique opportunities that others may overlook. Our sector specialists provide insights that drive informed investment decisions.</p>
              </div>
            </div>
            
            <div className="mk-pe-approach-point">
              <div className="mk-pe-approach-icon mk-pe-icon-partnership"></div>
              <div className="mk-pe-approach-info">
                <h3>Partnership Model</h3>
                <p>We view ourselves as partners rather than just investors. We work closely with management teams to develop and execute growth strategies, providing both capital and strategic guidance.</p>
              </div>
            </div>
            
            <div className="mk-pe-approach-point">
              <div className="mk-pe-approach-icon mk-pe-icon-data"></div>
              <div className="mk-pe-approach-info">
                <h3>Data-Driven Decisions</h3>
                <p>Our investment decisions are backed by comprehensive data analysis and market research. We leverage advanced analytics to identify trends, assess risks, and uncover hidden value.</p>
              </div>
            </div>
          </div>
          
          <h3 className="mk-pe-process-title">Our Four-Phase Investment Process</h3>
          <div className="mk-pe-process">
            <div className="mk-pe-process-step">
              <span className="mk-pe-step-number">01</span>
              <h4>Deal Origination</h4>
              <p>Proprietary sourcing through industry networks and relationships. We maintain an extensive network of industry contacts, intermediaries, and proprietary databases to identify promising investment opportunities before they come to market.</p>
              <ul className="mk-pe-step-details">
                <li>Proprietary deal flow generation</li>
                <li>Industry conference participation</li>
                <li>Executive relationship building</li>
              </ul>
            </div>
            <div className="mk-pe-process-step">
              <span className="mk-pe-step-number">02</span>
              <h4>Thorough Analysis</h4>
              <p>Comprehensive due diligence and financial modeling. Our team conducts exhaustive research including market analysis, competitive positioning, management assessment, and detailed financial modeling to evaluate each opportunity.</p>
              <ul className="mk-pe-step-details">
                <li>360-degree due diligence process</li>
                <li>Advanced financial modeling</li>
                <li>Industry expert consultations</li>
              </ul>
            </div>
            <div className="mk-pe-process-step">
              <span className="mk-pe-step-number">03</span>
              <h4>Active Management</h4>
              <p>Hands-on approach to value creation and growth. Post-investment, we work closely with portfolio companies to implement operational improvements, strategic initiatives, and growth acceleration plans.</p>
              <ul className="mk-pe-step-details">
                <li>100-day value creation plans</li>
                <li>Operational improvement initiatives</li>
                <li>Strategic growth acceleration</li>
              </ul>
            </div>
            <div className="mk-pe-process-step">
              <span className="mk-pe-step-number">04</span>
              <h4>Strategic Exit</h4>
              <p>Optimal timing and execution of exit strategies. We develop comprehensive exit plans from the initial investment phase, continuously monitoring market conditions to maximize returns through well-timed exits.</p>
              <ul className="mk-pe-step-details">
                <li>Multi-year exit planning</li>
                <li>IPO preparation and execution</li>
                <li>Strategic buyer engagement</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

        {/* CTA Section */}
        <section className="mk-pe-cta">
          <div className="mk-pe-cta-content">
            <h2>Ready to Explore Private Equity Opportunities?</h2>
            <p>
              Contact our team to learn how our private equity solutions can
              drive growth for your business
            </p>
            <a href="/contact-us">
              <button className="mk-pe-cta-button">Get in Touch</button>
            </a>
          </div>
        </section>
      </div>

      <Testimonial />

      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivateEquity;
